import {
  MDBBtn,
  MDBBtnGroup,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCardTitle,
  MDBChip,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBInput,
  MDBRadio,
  MDBRow,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBTooltip,
  MDBTypography
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { UserProfileContext } from '../context/UserProfileProvider';
import { generateQtnAnsPDF, ImageDisplay } from '../utils/Common';
import RecursiveParagraph from '../utils/RecursiveParagraph';
import RenderDescriptions from '../utils/RenderParagraphs';
import FeedbackAccordion from './FeedbackAccordion';
const FeatureForm = ({
  demoId,
  feature,
  featureIndex,
  isEdit,
  handleChange,
  handleAddImageUrl,
  handleRemoveImageUrl,
  handleImageUrlChange,
  handlePainPromiseChange,
  addPainPromise,
  removePainPromise,
  modalOpen, // These three are needed for ImageDisplay
  setModalOpen,
  toggleModal,
  removeImpact,
  addImpact,
  addFeedback,
  setActiveAccordions,
  activeAccordions,
  demoUser,handleCheckboxChange,addCheckbox,removeCheckbox ,handleCheckboxLabelChange,addQuestion,
  removeQuestion,
  handleQuestionInputChange,
  handleAnswerInputChange,
  handleFeedbackUserChange,removeFeedback, handleUpdateForNonLoggedinFeedBackUser,
  addSubFeature,
  removeSubFeature,
  setFormData,
  setCentredModal,
  handleCloseModal,
  setSelectedFeature
 
}) => {
  const { tokenLoaded } = useContext(UserProfileContext);
  const [textData, setTextData] = useState(feature.paragrapDescriptions || []);

  // Sync textData from feature.paragrapDescriptions
  useEffect(() => {
   
    setTextData(feature.paragrapDescriptions || []);
  }, [feature]);


 // Function to calculate the maximum depth of nested paragraphs
const getMaxDepth = (paragraphs) => {
  if (!paragraphs || !Array.isArray(paragraphs)) return 0;

  let maxDepth = 0;
  paragraphs.forEach((paragraph) => {
    if (paragraph.paragraphs && paragraph.paragraphs.length > 0) {
      const depth = getMaxDepth(paragraph.paragraphs);
      maxDepth = Math.max(maxDepth, depth + 1);
    }
  });
  return maxDepth;
};
const renderParagraphs = (paragraphs) => {
  return paragraphs.map((paragraph, idx) => (
    <div key={paragraph.id} className={`mt-2 ${paragraph.fontSize || 'fs-6'}`}>
      {/* Render the paragraph's textValue */}
      {paragraph.textValue && <div>{paragraph.textValue}</div>}
      {/* If the paragraph has nested paragraphs, render them recursively */}
      {paragraph.paragraphs && paragraph.paragraphs.length > 0 && renderParagraphs(paragraph.paragraphs)}
    </div>
  ));
};


   // Sync textData changes to formData globally
   useEffect(() => {
    setFormData((prevState) => {
      const updatedOrchestration = prevState.orchestration.map((feature, i) => {
        if (i === featureIndex) {
          return { ...feature, paragrapDescriptions: textData };
        }
        return feature;
      });
      return { ...prevState, orchestration: updatedOrchestration };
    });
  }, [textData, setFormData, featureIndex]);


  const handleAddDescription = useCallback(
    (indexPath) => {
      setFormData((prevState) => {
        // Create a deep copy of the orchestration state to ensure immutability
        const updatedOrchestration = [...prevState.orchestration];
        const path = typeof indexPath === 'string' && indexPath.includes('-')
          ? indexPath.split('-').map((i) => parseInt(i, 10))
          : [parseInt(indexPath, 10)];
  
        let targetFeature = { ...updatedOrchestration[path[0]] };
  
        // Traverse sub-features using the path for deeper nested features
        let parentFeature = updatedOrchestration;
        for (let i = 1; i < path.length; i++) {
          parentFeature = targetFeature;
          targetFeature = { ...targetFeature.subFeatures[path[i]] };
        }
  
        // Generate a new description object
        const newDescription = {
          id: uuidv4(),
          textValue: '',
          textColor: 'black',
          textSize: 'h5',
          fontSize: 'fs-6',
          type: 'caption',
          orderNumber: (targetFeature.paragrapDescriptions?.length || 0) + 1,
          paragraphs: [],
          heading: {
            id: uuidv4(),
            textValue: '',
            textColor: 'black',
            textSize: 'h2',
            fontSize: 'fs-4',
            type: 'caption',
          },
        };
  
        // Update the paragraph descriptions
        targetFeature.paragrapDescriptions = targetFeature.paragrapDescriptions
          ? [...targetFeature.paragrapDescriptions, newDescription]
          : [newDescription];
        // If it's a sub-feature, update its parent reference in the orchestration
        if (path.length > 1) {
          parentFeature.subFeatures[path[path.length - 1]] = targetFeature;
        } else {
          updatedOrchestration[path[0]] = targetFeature;
        }
  
        // Return the new formData with a fresh copy of the orchestration
        return { ...prevState, orchestration: [...updatedOrchestration] };
      });
    },
    [setFormData]
  );
  
  const [isAddingFeedback, setIsAddingFeedback] = useState(false);
  const handleAddFeedback = (featurePath) => {
    if (isAddingFeedback) return;
    setIsAddingFeedback(true);
  
    addFeedback(featurePath);
  
    // Reset the flag after adding feedback
    setTimeout(() => {
      setIsAddingFeedback(false);
    }, 100); // A small delay to allow React to process the update
  };
  

  
  const memoizedRecursiveParagraph = useMemo(
    () => (
      <RecursiveParagraph
        featureName={feature.name}
        textData={textData}
        featureIndex={featureIndex}
        onParagraphToggle={() => {}}
        setFormData={setFormData} // Directly pass setFormData
        setTextData={setTextData}
        contextType={"paragraphDescriptions"}
      />
    ),
    [textData, setFormData, featureIndex, feature.name]
  );


  return (
    <div className="mb-2 mt-2 text-center align-items-center justify-content-center" >



    <div>
        {/* Sub-Features Section */}
        {isEdit && (
          <div className="mb-3">
         
         {feature?.subFeatures && feature.subFeatures.length > 0 && (
  <div>
    {feature.subFeatures.map((subFeature, subIndex) => (
      <div key={`${subFeature.id}-${subIndex}`} className="mb-4">
        <MDBCard>
          <MDBCardBody>
            {subFeature?.name && <MDBCardTitle>{subFeature.name}</MDBCardTitle>}
            
            <FeatureForm
              setCentredModal={setCentredModal}
              demoId={demoId}
              feature={subFeature}
              featureIndex={`${featureIndex}-${subIndex}`} // Pass the updated index for sub-features
              isEdit={isEdit}
              handleChange={handleChange}
              handleAddImageUrl={handleAddImageUrl}
              handleRemoveImageUrl={handleRemoveImageUrl}
              handleImageUrlChange={handleImageUrlChange}
              handlePainPromiseChange={handlePainPromiseChange}
              addPainPromise={addPainPromise}
              removePainPromise={removePainPromise}
              removeImpact={removeImpact}
              addImpact={addImpact}
              activeAccordions={activeAccordions}
              setActiveAccordions={setActiveAccordions}
              demoUser={demoUser}
              handleCheckboxChange={handleCheckboxChange}
              addCheckbox={addCheckbox}
              removeCheckbox={removeCheckbox}
              handleCheckboxLabelChange={handleCheckboxLabelChange}
              addQuestion={addQuestion}
              removeQuestion={removeQuestion}
              handleQuestionInputChange={handleQuestionInputChange}
              handleAnswerInputChange={handleAnswerInputChange}
              handleFeedbackUserChange={handleFeedbackUserChange}
              removeFeedback={removeFeedback}
              toggleModal={toggleModal}
              modalOpen={modalOpen}
              handleUpdateForNonLoggedinFeedBackUser={handleUpdateForNonLoggedinFeedBackUser}
              addFeedback={addFeedback}
              addSubFeature={addSubFeature}
              removeSubFeature={removeSubFeature}
              setFormData={setFormData}
              handleCloseModal={handleCloseModal}
              setSelectedFeature={setSelectedFeature}
            />
          </MDBCardBody>

          <MDBBtn
            type="button"
            color="danger"
            onClick={() => removeSubFeature(featureIndex, subIndex)}
          >
            Remove Sub-Feature
          </MDBBtn>
        </MDBCard>
      </div>
    ))}
  </div>
)}



          </div>
        )}


      {isEdit ? (
    
        <>
          <MDBRow className=" align-items-center justify-content-center">
            <MDBCol>
              <MDBRow>
                <MDBCol>
                  <MDBInput
                    id={`feature_input_Name-${featureIndex}`}
                    label="Feature Name"
                    className="mb-2"
                    value={feature.name}
                    onChange={(e) => handleChange(featureIndex, null, null, 'name', e.target.value)}
                  />
                </MDBCol>
                <MDBCol>
                  <MDBInput  min="1"
                    label="Order Of This Slide"
                    id="slideNumber"
                    type="number"
                    value={feature.slideNumber}
                    onChange={(e) => handleChange(featureIndex, null, null, 'slideNumber', e.target.value)}
                  />
                </MDBCol>
               
                  <MDBCol className="mb-2">
                    <ImageDisplay feature={feature}  toggleModal={toggleModal} modalOpen={modalOpen}/>
                  </MDBCol>
              
              </MDBRow>

              <MDBRow className="mb-2">
                <MDBCol>
                  {feature.imageType === 'carousel' ? (
                    feature.imageUrls?.map((url, urlIndex) => (
                      <div key={`url-${urlIndex}`} className="d-flex align-items-center mb-2">
                        <MDBBtn
                          size="sm"
                          color="link"
                          onClick={() => handleRemoveImageUrl(featureIndex, urlIndex)}
                          type="button"
                        >
                          <MDBIcon fas icon="minus" className="cursor-pointer" />
                        </MDBBtn>
                        <MDBInput
                          label={`Image URL ${urlIndex + 1}`}
                          value={url}
                          onChange={(e) => handleImageUrlChange(featureIndex, urlIndex, e.target.value)}
                          className="flex-grow-1 mt-2"
                        />
                       
                      </div>
                    ))
                  ) : feature.imageType === 'video' ? (
                    <MDBInput
                      type="url"
                      id={`feature_input_video_Url-${featureIndex}`}
                      label="Video URL"
                      className="mb-2"
                      value={feature.videoUrl || 'https://opengrit.com/images/xtrkldemo'}
                      onChange={(e) => handleChange(featureIndex, null, null, 'videoUrl', e.target.value)}
                    />
                  ) : (
                    <MDBInput
                      label="Image URL"
                      value={feature.imageUrl || 'https://mdbootstrap.com/img/new/standard/city/041.webp'}
                      onChange={(e) => handleChange(featureIndex, null, null, 'imageUrl', e.target.value)}
                    />
                  )}
{feature.imageType === 'carousel' &&
<MDBBtn
                          size="sm"
                          color="link"
                          onClick={() => handleAddImageUrl(featureIndex)}
                          type="button"
                        >
                         Add Image Url
                        </MDBBtn> }
                </MDBCol>
                <MDBCol>
                  <div className="mt-2">
                    <MDBRadio
                      name={`inlineRadio-${featureIndex}`}
                      id={`inlineRadio-image-${featureIndex}`}
                      value="image"
                      label="Image"
                      inline
                      checked={feature.imageType === 'image'}
                      onChange={(e) => handleChange(featureIndex, null, null, 'imageType', e.target.value)}
                    />
                    <MDBRadio
                      name={`inlineRadio-${featureIndex}`}
                      id={`inlineRadio-video-${featureIndex}`}
                      value="video"
                      label="Video"
                      inline
                      checked={feature.imageType === 'video'}
                      onChange={(e) => handleChange(featureIndex, null, null, 'imageType', e.target.value)}
                    />
                    <MDBRadio
                      name={`inlineRadio-${featureIndex}`}
                      id={`inlineRadio-carousel-${featureIndex}`}
                      value="carousel"
                      label="Carousel"
                      inline
                      checked={feature.imageType === 'carousel'}
                      onChange={(e) => handleChange(featureIndex, null, null, 'imageType', e.target.value)}
                    />
                  </div>
                </MDBCol>
              </MDBRow>

              <MDBRow className="align-items-center mb-3">
 
      <section className=" mx-auto position-relative" style={{ marginTop: '10px' }}>
     

   {isEdit && <section    className=" align-items-center justify-content-center">{memoizedRecursiveParagraph}</section>}


      </section>
    </MDBRow>


 
            </MDBCol>
          </MDBRow>

<div className="position-relative">

<MDBBtn onClick={() => addPainPromise(featureIndex)} type="button" size="sm"  className="position-absolute top-0 end-0 translate-middle m-1">
                  <MDBIcon fas icon="add" size="sm" />
                  </MDBBtn>
</div>
<MDBRow className="align-items-center mb-3">
<MDBChip
              size="md"
              className="align-items-center text-center justify-content-center flex-wrap w-100"
              style={{
                minHeight: '40px',
                height: 'auto',
                width: '100%',
                padding: '10px',
                wordBreak: 'break-word',
                whiteSpace: 'normal',
                overflowWrap: 'break-word',
              }}
            >
  <h4 className="text-center mt-2 text-primary">So What?</h4>
  </MDBChip>
 
  <MDBTable align="middle">
    <MDBTableHead>
      <tr>
        <th scope="col" className="w-50 text-center">Pain</th>
        <th scope="col" className="w-50 text-center">Promise</th>
      </tr>
    </MDBTableHead>
    <MDBTableBody>
    {feature.painPromise && feature.painPromise.length > 0 ? (
      feature.painPromise.map((painPromise, i) => (
          <tr key={i} className="position-relative">
            <td className="text-start">
              {/* <MDBTextArea
                wrapperClass="mb-2"
                value={painKey.replace(/[.:]/g, '-')}
                onChange={(e) => handlePainKeyChange(index, painKey, e.target.value)} // Adjusted for sub-features
              /> */}
  <RecursiveParagraph
              textData={[painPromise.pain]}  // Pass pain as textData
              featureIndex={featureIndex}  // The current feature index
              setFormData={setFormData}
              setTextData={() => {}}
              contextType={'pain'}
            />

            </td>
            <td className="text-start">
              {/* <MDBTextArea
                wrapperClass="mb-2"
                value={feature.painPromise[painKey]}
                onChange={(e) => handlePainPromiseChange(index, painKey, e.target.value)} // Adjusted for sub-features
              /> */}

<RecursiveParagraph
              textData={[painPromise.promise]}  // Pass promise as textData
              featureIndex={featureIndex}  // The current feature index
              setFormData={setFormData}
              setTextData={() => {}}
              contextType={'promise'}
            />
            </td>
            <MDBBtn
              type="button"
              className="position-absolute top-0 end-0 translate-middle m-1"
              tag="a"
              style={{ color: '#dd4b39' }}
              color="none"
              onClick={(e) => {e.preventDefault(); removePainPromise(featureIndex, painPromise.id)}} // Adjusted for sub-features
            >
              <MDBTooltip tag="a" wrapperProps={{ href: '#' }} title="Remove this Pain Promise">
                <MDBIcon fas icon="times-circle" color="danger" size="sm" />
              </MDBTooltip>
            </MDBBtn>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={2}>No Pain/Promise data available</td>
        </tr>
      )}
    </MDBTableBody>
  </MDBTable>

 
</MDBRow>

        </>
      ) : (
        <>
         
          <div >
          <MDBRow className='mb-2 align-items-center justify-content-between' >
  {/* <MDBCol xs="12" md="6" className='d-flex justify-content-center'>
    <MDBCardTitle className='text-center'>{feature?.name}</MDBCardTitle>
  </MDBCol>
  <MDBCol xs="12" md="6" className='d-flex justify-content-center'> */}
  <div className='button-container'>
  <MDBBtnGroup> 
    
    <ImageDisplay feature={feature} modalOpen={modalOpen} setModalOpen={setModalOpen} toggleModal={toggleModal} />
    <MDBBtn
      type="button" size='lg roundeded'
      className="bg-primary text-black bg-opacity-75 "
      onClick={() => generateQtnAnsPDF(`${demoId}`)}
    >
      PDFGen
    </MDBBtn></MDBBtnGroup> 
    </div>
  {/* </MDBCol> */}
</MDBRow>

              
{/* {feature?.paragrapDescriptions && feature.paragrapDescriptions.length > 0 ? (
    renderDescriptions(feature.paragrapDescriptions)
  ) : (
    <p>{feature?.description}</p>
  )} */}

{Array.isArray(feature?.paragrapDescriptions) && feature?.paragrapDescriptions?.length > 0 && 
  <RenderDescriptions descriptions={feature.paragrapDescriptions} />
}


          </div>
{ Object.keys(feature?.painPromise).length > 0 && <MDBContainer>


  <MDBChip
              size="md"
              className="align-items-center text-center justify-content-center flex-wrap w-100"
              style={{
                minHeight: '40px',
                height: 'auto',
                maxWidth: '300px', // Set a max width for the chip
                padding: '10px',
                wordBreak: 'break-word',
                whiteSpace: 'normal',
                overflowWrap: 'break-word',
                display: 'inline-block', // Make the chip fit its content
              }}
            >
  <h4 className="text-center mt-2 text-primary">So What?</h4>
  </MDBChip>
 
  <MDBTable align="middle" borderless className='text-center'>
  <MDBTableHead>
    <tr>
      <th scope="col" className="w-50">
        <MDBChip size="md" className='align-items-center text-center justify-content-center'>Pain</MDBChip>
      </th>
      <th scope="col" className="w-50">
        <MDBChip size="md" className='align-items-center text-center justify-content-center'>Promise</MDBChip>
      </th>
    </tr>
  </MDBTableHead>
  <MDBTableBody>
    {feature.painPromise && feature.painPromise.length > 0 ? (
      feature.painPromise.map((painPromise, i) => (
        <tr key={i}>
          <td className={`text-start ${painPromise?.pain.fontSize || 'fs-6'}`}>
            {/* Render the main text value */}
            {painPromise.pain?.heading?.textValue &&  <div className="chip-content">
              {painPromise?.pain?.heading?.textValue && (
                <MDBTypography
                  tag={`${painPromise?.pain?.heading?.textSize || 'h4'}`}
                  
                  className={`${painPromise.pain.heading?.textColor || 'text-primary'} fw-bold mb-1 text-capitalize ${painPromise.pain.heading.fontSize}`}
                >
                  {painPromise?.pain?.heading?.textValue }
                </MDBTypography>
              )}
              {painPromise?.pain?.textValue && (
                <figcaption className="blockquote-footer mb-0 ">
                  <cite title={painPromise.pain.textValue} className={`${painPromise.pain?.textColor || 'text-success'} fw-bold `}>
                    {painPromise.pain.textValue}
                  </cite>
                </figcaption>
              )}
            </div>}
            {/* Recursively render paragraphs */}
            {painPromise.pain?.paragraphs?.length > 0 && renderParagraphs(painPromise.pain.paragraphs)}
          </td>
          <td className={`text-start ${painPromise.promise.fontSize || 'fs-6'}`}>
            {/* Render the main text value */}
            {painPromise.promise?.textValue && <div>{painPromise.promise.textValue}</div>}
            {/* Recursively render paragraphs */}
            {painPromise.promise?.paragraphs?.length > 0 && renderParagraphs(painPromise.promise.paragraphs)}
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={2}>No Pain/Promise data available</td>
      </tr>
    )}
  </MDBTableBody>
</MDBTable>

          
          </MDBContainer>}
          
        </>
      )
      
      
      }
    </div>
    <div className='mb-3 button-container text-center align-items-center justify-content-center'>
  {(feature.feedbacks || feature.isNew || tokenLoaded) && feature.feedbacks.length >= 1 && (
    <MDBCardHeader>
      <h3 className='text-black'>Feedbacks</h3>
    </MDBCardHeader>
  )}

  {
    <div className='text-center align-items-center justify-content-center'>
      <FeedbackAccordion
        addImpact={addImpact}
        removeImpact={removeImpact}
        key={featureIndex}
        feature={feature}
        featureIndex={featureIndex}
        feedbacks={feature.feedbacks.filter(
          (feedback) =>
            // Check if there's at least one non-empty impact or one answer in the questions
            (feedback.impactsOnYourBusiness && feedback.impactsOnYourBusiness.some(impact => impact.trim() !== '')) ||
            (feedback.questions && feedback.questions.some(question => question.answer.trim() !== '')) || tokenLoaded
        )}
        handleChange={handleChange}
        isEdit={isEdit}
        activeAccordions={activeAccordions}
        setActiveAccordions={setActiveAccordions}
        demoUser={demoUser}
        addFeedback={addFeedback}
        handleCheckboxChange={handleCheckboxChange}
        addCheckbox={addCheckbox}
        removeCheckbox={removeCheckbox}
        handleCheckboxLabelChange={handleCheckboxLabelChange}
        addQuestion={addQuestion}
        removeQuestion={removeQuestion}
        handleQuestionInputChange={handleQuestionInputChange}
        handleAnswerInputChange={handleAnswerInputChange}
        handleFeedbackUserChange={handleFeedbackUserChange}
        removeFeedback={removeFeedback}
        demoId={demoId}
        handleUpdateForNonLoggedinFeedBackUser={handleUpdateForNonLoggedinFeedBackUser}
        setCentredModal={setCentredModal}
        setFormData={setFormData}
      />
    </div>
  }
</div>





                  
  <MDBBtnGroup className="mb-3">
    {/* Add Sub-Feature Button */}
    {isEdit && <>   <MDBBtn color="success" onClick={() => addSubFeature(feature.id)} type="button">
      Add Sub-Feature
    </MDBBtn>

    
    <MDBBtn
      type="button"
      size="sm"
      color="link"
     
      onClick={() => handleAddDescription(featureIndex)} // Trigger handleAddDescription for the current feature
    >
      <MDBIcon fas icon="plus-circle" /> Add Description
    </MDBBtn></>}
   
    <MDBBtn 
  color="primary" 
  type="button" 
  onClick={() => handleAddFeedback(featureIndex)}
  disabled={isAddingFeedback}
>
  Add New Feedback
</MDBBtn>

     
          
  </MDBBtnGroup>


  </div>

  );

 
};
FeatureForm.propTypes = {
    feature: PropTypes.shape({
      isNew: PropTypes.bool,
      id: PropTypes.string,
      subFeatures: PropTypes.array,
      name: PropTypes.string,
      slideNumber: PropTypes.number,
      imageType: PropTypes.string,
      imageUrl: PropTypes.string,
      videoUrl: PropTypes.string,
      imageUrls: PropTypes.arrayOf(PropTypes.string),
      descriptions: PropTypes.arrayOf(PropTypes.string),
      paragrapDescriptions:PropTypes.arrayOf(PropTypes.object),
      painPromise: PropTypes.object,
      feedbacks: PropTypes.array,
      description: PropTypes.string,
    }), // Feature object with nested properties
    featureIndex: PropTypes.number,   // Ensuring index is required and must be a number
    isEdit: PropTypes.bool,    // Ensure isEdit is a boolean
    handleChange: PropTypes.func, // Function handlers should be required
    handleAddDescription: PropTypes.func,
    handleRemoveDescription: PropTypes.func,
    handleAddImageUrl: PropTypes.func,
    handleRemoveImageUrl: PropTypes.func,
    handleImageUrlChange: PropTypes.func,
    handlePainPromiseChange: PropTypes.func,
    addPainPromise: PropTypes.func,
    removePainPromise: PropTypes.func,
    modalOpen: PropTypes.bool, // Modal open state
    setModalOpen: PropTypes.func,
    toggleModal: PropTypes.func,
    removeImpact: PropTypes.func,
    addImpact: PropTypes.func,
    setActiveAccordions: PropTypes.func,
    activeAccordions: PropTypes.array,
    addFeedback: PropTypes.func,
    demoUser: PropTypes.object,
    handleCheckboxChange: PropTypes.func,
    addCheckbox: PropTypes.func,
    removeCheckbox: PropTypes.func ,
    handleCheckboxLabelChange: PropTypes.func,
    addQuestion:  PropTypes.func,
    removeQuestion:  PropTypes.func,
    handleQuestionInputChange:  PropTypes.func,
    handleAnswerInputChange:  PropTypes.func,
    handleFeedbackUserChange: PropTypes.func,
    removeFeedback: PropTypes.func,
    demoId:PropTypes.string,
    handleUpdateForNonLoggedinFeedBackUser:PropTypes.func,
    activeSlideIndex: PropTypes.number,
    addSubFeature: PropTypes.func,
    removeSubFeature: PropTypes.func,
    setFormData: PropTypes.func,
    setCentredModal: PropTypes.func,
    handleCloseModal: PropTypes.func,
    setSelectedFeature: PropTypes.func,
 
}
  
export default FeatureForm;
